import { render, staticRenderFns } from "./user-audit-record.vue?vue&type=template&id=71189ab3&scoped=true"
import script from "./user-audit-record.vue?vue&type=script&lang=js"
export * from "./user-audit-record.vue?vue&type=script&lang=js"
import style0 from "./user-audit-record.vue?vue&type=style&index=0&id=71189ab3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71189ab3",
  null
  
)

export default component.exports